import { Button } from 'primereact/button';
import { ProgressBar } from 'primereact/progressbar';
import { Toast } from 'primereact/toast';
import { FC, MutableRefObject, useRef } from 'react';
import { useAppDispatch } from '../../redux/hooks';
import { setCsvProcess } from '../../redux/reducers/csvProcessSlice';
import { setReportHubQuerysInProgress } from '../../redux/reducers/reportHubQuerysInProgress';
import { Panel } from 'primereact/panel';

interface Props {
  downloadToastRef: MutableRefObject<Toast | null>;
  clear: () => void;
  progressValueToast?: number | null;
  progressBarType?: 'determinate' | 'indeterminate' | undefined;
}

const ToastExportXLSorCSV: FC<Props> = ({
  downloadToastRef,
  clear,
  progressValueToast = null,
  progressBarType = 'determinate',
}) => {
  const dispatch = useAppDispatch();
  const ref = useRef<Panel>(null);

  const header = (header: string) => {
    return (
      <p className="m-0 font-semibold text-base text-white nc_toast-font-family" style={{ lineHeight: '24px' }}>
        {header}
      </p>
    );
  };
  return (
    <Toast
      ref={downloadToastRef}
      onRemove={clear}
      position="bottom-center"
      appendTo={document.body}
      content={({ message }) => (
        <Panel
          ref={ref}
          header={header(message.summary)}
          toggleable
          style={{ borderRadius: '10px', backgroundColor: '#357AF6' }}
          collapseIcon="pi pi-chevron-down"
          expandIcon="pi pi-chevron-up"
          className="nc_panel-toast"
        >
          <section
            className="flex flex-column px-3 pb-3 w-full nc_toast-align font-sans align-items-start"
            style={{ borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px', backgroundColor: '#357AF6' }}
          >
            <div className="flex flex-column gap-1 w-full">
              <div className="nc_toast-align">
                <p className="m-0 text-sm text-white nc_toast-font-family"> This may take a few minutes.</p>
              </div>
              <div className="flex flex-column gap-2">
                <div className="nc_toast-align">
                  <ProgressBar
                    mode={progressBarType}
                    style={{ height: '9px', backgroundColor: '#FFFFFF80', width: '86%' }}
                    showValue={false}
                    value={progressValueToast}
                    className="inline-block"
                  ></ProgressBar>
                  <Button
                    icon="pi pi-times"
                    onClick={() => {
                      clear();
                      dispatch(setCsvProcess(false));
                      dispatch(setReportHubQuerysInProgress(false));
                    }}
                  />
                </div>
                {progressValueToast !== null && (
                  <label className="text-right text-xs text-white">{progressValueToast}% downloaded...</label>
                )}
              </div>
            </div>
          </section>
        </Panel>
      )}
    ></Toast>
  );
};

export default ToastExportXLSorCSV;
